import { ICartProduct } from '../../generalTypes'
import { IProduct } from '../CategoriesReducer/types'

export const initialState: IBucket = {
  products: [],
}

export interface IBucket {
  products: IBucketProduct[]
}

export interface IMenuItemsBucket {
  count: number
  kitchenInfo: any[]
  name: string
  price: string
  productId: number
  menuIndex: number
  imageUrl?: string
  categoryId_origin?: number
  categoryId?: number
  isFixed?: boolean
}

export type ProductTemplateIdType = number | 'discount' | 'individualPrice'

export interface IBucketProduct extends ICartProduct {
  menuItems?: IMenuItemsBucket[]
  kitchenInfo: string
  addedAsWeight: boolean
  uniqueId: string
  productTemplateId: ProductTemplateIdType
}

export interface IProductWithBucketProduct
  extends Omit<IProduct, 'kitchenInfo'>,
    IBucketProduct {
  kitchenInfo: string
  uniqueId: string
  menuItems: any[]
  // not sure if productTemplateId is needed here
  productTemplateId: number
}
